import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import HowGiftsWork from '../HowGiftsWork';
import DefaultPicture from '../../components/01_atoms/DefaultPicture';
import FormattedText from '../../components/01_atoms/FormattedText';
import ProductPrice from '../ProductPrice';
import AddToBasketButton from '../AddToBasketButton';
import AddDonationForm from './AddDonationForm';
import { isCustomPrice } from '../../utils/Gifts/products';
import { SiteSettingsContext } from '../../utils/context';

import styles from './index.module.scss';

const CorporateGiftPage = ({ gift }) => {
  const [activeTab, setActiveTab] = useState('description');

  const { corporateGiftPage } = useContext(SiteSettingsContext);

  return (
    <div className={`${styles['corporate-gift-page']}`}>
      <div className="container">
        <div className={styles['corporate-gift-page__picture']}>
          <DefaultPicture {...gift.image} loading="lazy" />
        </div>
        <h1 className={styles['corporate-gift-page__title']}>{gift.title}</h1>
        {!isCustomPrice(gift) && (
          <div className={styles['corporate-gift-page__price']}>
            <ProductPrice product={gift} />
          </div>
        )}
        <FormattedText text={gift.annotation} className={styles['corporate-gift-page__annotation']} />
        <div className={styles['corporate-gift-page__actions']}>
          {!isCustomPrice(gift) && <AddToBasketButton product={gift} />}
          {isCustomPrice(gift) && <AddDonationForm product={gift} />}
        </div>
        <ul className={styles['corporate-gift-page__tabs']}>
          <li
            onClick={() => setActiveTab('description')}
            className={`${styles['corporate-gift-page__tabs_tab']} ${activeTab === 'description' ? styles['corporate-gift-page__tabs_tab--selected'] : ''}`}
          >
            Description
          </li>
          <li
            onClick={() => setActiveTab('how-gifts-work')}
            className={`${styles['corporate-gift-page__tabs_tab']} ${activeTab === 'how-gifts-work' ? styles['corporate-gift-page__tabs_tab--selected'] : ''}`}
          >
            How gifts work
          </li>
        </ul>
        {activeTab === 'description' && (
          <div className={styles['corporate-gift-page__description']}>
            <div className={styles['corporate-gift-page__description_image']}>
              <DefaultPicture {...gift.actionImage} loading="lazy" />
            </div>
            <FormattedText
              text={gift.shortDescription}
              className={styles['corporate-gift-page__description_body']}
            />
          </div>
        )}
        {activeTab === 'how-gifts-work' && <HowGiftsWork items={corporateGiftPage} />}
      </div>
    </div>
  );
};

CorporateGiftPage.propTypes = {
  gift: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.object,
    url: PropTypes.object,
    image: PropTypes.object,
    actionImage: PropTypes.object,
    shortDescription: PropTypes.string,
    annotation: PropTypes.string,
  }).isRequired,
};

export default CorporateGiftPage;
